<app-nav-steps *ngIf="!isReadOnly"></app-nav-steps>
<form *ngIf="technicianDataFG" [formGroup]="technicianDataFG" class="component-container technician-form-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div *ngIf="currentFlowType === installationFlowType.NewInstallation" class="page-heading text-center text-uppercase">
      {{ 'facilities-data.' + currentFormType.key | translate }}
      <span *ngIf="isReadOnly">- {{ 'overview.jurisdiction-overview.application_id' | translate }} {{ externalApplicationId }}</span>
    </div>
    <div *ngIf="currentFlowType === installationFlowType.UpdateInstallation" class="page-heading text-center text-uppercase">
      {{ 'facilities-data.update-installation.' + currentFormType.key | translate }}
      <span *ngIf="isReadOnly">- {{ 'overview.jurisdiction-overview.application_id' | translate }} {{ externalApplicationId }}</span>
    </div>
    <div
      *ngIf="currentFlowType !== installationFlowType.UpdateInstallation && currentFlowType !== installationFlowType.NewInstallation"
      class="page-heading text-center text-uppercase">
      {{ 'installation-data.' + getFlowTitle() | translate }}
      <span *ngIf="isReadOnly">- {{ 'overview.jurisdiction-overview.application_id' | translate }} {{ externalApplicationId }}</span>
    </div>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align text-uppercase page-title">
      {{ 'technician-data.technical-data-title' | translate }}
      <span *ngIf="currentFlowType === installationFlowType.MainsConnection">
        - {{ 'lookup.' + buildingTypeKey + '.options.' + currentFormType.lookUpKey + '.name' | translate }}
      </span>
      <span
        *ngIf="currentFlowType === installationFlowType.ChangeHouseConnection || currentFlowType === installationFlowType.ConversionToGas">
        - {{ 'lookup.' + changeSubtypeKey + '.options.' + currentFormType.lookUpKey + '.name' | translate }}
      </span>
    </div>
  </div>

  <div *ngIf="currentFlowType !== installationFlowType.TemporaryConnection && currentFlowType !== installationFlowType.ConversionToGas">
    <app-review-section
      [title]="'personal-data.media' | translate"
      [tooltip]="'tooltips.technician-form.media' | translate"
      [showTooltip]="infoBubblesData?.showMediaInfo"
      [sectionId]="sectionIdentifier.TechnicalData_Media"
      [applicationId]="applicationId"
      [isDetailsView]="isDetailsView"
      [showAcceptRejectButtons]="false"
      [showMessages]="showReviewSectionMessaging"></app-review-section>
    <div
      class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
      [ngClass]="disabledMediaOptions ? 'disabled-section' : ''">
      <div class="ui-g-3 center_aligned" *ngIf="mediumVisibility?.power">
        <span
          (click)="selectMedia($event)"
          class="icon icon-electricity pointer-cursor"
          id="power"
          [ngClass]="changePower === '1' ? 'active-icon' : ''"></span>
        <div class="icon-label" [ngClass]="changePower === '1' ? 'active-icon-label' : ''">
          {{ 'overview.details-data.data-rows.power' | translate }}
        </div>
      </div>
      <div class="ui-g-3 center_aligned" *ngIf="mediumVisibility?.gas">
        <span
          (click)="selectMedia($event)"
          class="icon icon-gas pointer-cursor"
          id="gas"
          [ngClass]="changeGas === '1' ? 'active-icon' : ''"></span>
        <div class="icon-label" [ngClass]="changeGas === '1' ? 'active-icon-label' : ''">
          {{ 'overview.details-data.data-rows.gas' | translate }}
        </div>
      </div>
      <div class="ui-g-3 center_aligned" *ngIf="mediumVisibility?.water && !hideCommodityWater">
        <span
          (click)="selectMedia($event)"
          class="icon icon-water pointer-cursor"
          id="water"
          [ngClass]="changeWater === '1' ? 'active-icon' : ''"></span>
        <div class="icon-label" [ngClass]="changeWater === '1' ? 'active-icon-label' : ''">
          {{ 'overview.details-data.data-rows.water' | translate }}
        </div>
      </div>
      <div class="ui-g-3 center_aligned" *ngIf="mediumVisibility?.heating">
        <span
          (click)="selectMedia($event)"
          class="icon icon-geothermal pointer-cursor"
          id="heating"
          [ngClass]="changeHeat === '1' ? 'active-icon' : ''"></span>
        <div class="icon-label" [ngClass]="changeHeat === '1' ? 'active-icon-label' : ''">
          {{ 'overview.details-data.data-rows.heating' | translate }}
        </div>
      </div>
    </div>
  </div>

  <app-technician-base-data
    *ngIf="showBaseDataSection"
    [baseData]="baseData"
    [currentFormType]="currentFormType"
    [isReadOnly]="isReadOnly"
    [selectedFacilities]="changeFacilities"
    [applicationId]="applicationId"
    [isDetailsView]="isDetailsView"></app-technician-base-data>

  <app-power-connection
    *ngIf="showComponent.power && changeConnectionType !== 'shutdown'"
    [currentFormType]="currentFormType"
    [isReadOnly]="isReadOnly"
    [isDetailsView]="isDetailsView"
    [applicationId]="applicationId"
    [applicationStatus]="applicationStatus"
    [powerConnectionData]="powerConnectionData"
    (onPowerConnectionReviewSet)="onPowerConnectionReviewSet.emit($event)"
    (onPowerConnectionLocationChange)="onPowerConnectionLocationChange.emit($event)"></app-power-connection>

  <app-gas-connection
    *ngIf="showComponent.gas && changeConnectionType !== 'shutdown'"
    [currentFormType]="currentFormType"
    [gasConnectionData]="gasConnectionData"
    [isReadOnly]="isReadOnly"
    [isDetailsView]="isDetailsView"
    [applicationId]="applicationId"></app-gas-connection>

  <app-heating-connection
    *ngIf="showComponent.heating && changeConnectionType !== 'shutdown'"
    [currentFormType]="currentFormType"
    [heatingConnectionData]="heatingConnectionData"
    [isReadOnly]="isReadOnly"
    [isDetailsView]="isDetailsView"
    [applicationId]="applicationId"></app-heating-connection>

  <app-water-connection
    *ngIf="showComponent.water && changeConnectionType !== 'shutdown'"
    [currentFormType]="currentFormType"
    [isReadOnly]="isReadOnly"
    [waterConnectionData]="waterConnectionData"
    [isDetailsView]="isDetailsView"
    [applicationId]="applicationId"></app-water-connection>

  <div *ngIf="!isReadOnly" class="ui-g-12 submit-button-section bottom-padding">
    <div
      [class]="
        'ui-g-12 button-group ' + (!showDeterminePriceButton && currentFlowType === installationFlowType.MainsConnection ? 'centered' : '')
      ">
      <div *ngIf="showDeterminePriceButton && currentFlowType === installationFlowType.MainsConnection" class="ui-g-10 button-group">
        <button
          class="ui-g-6 submit-button"
          [disabled]="evaluateFormValidity()"
          label="{{ 'basic-profile.jurisdiction.determine-price-button' | translate }}"
          (click)="determinePrice()"
          pButton></button>
        <label class="small-field-width text-right-align">{{ technicianDataFG.get('price').value }}</label>
        <span *ngIf="showLabelAndUnit" class="field-unit-label">{{ 'technician-data.gross-price-label' | translate }}</span>
        <span class="field-unit-label">{{ unitLabels.price }}</span>
        <span *ngIf="isPriceUndetermined" class="undetermined-price-message">
          {{ 'technician-data.undetermined-price-message' | translate }}
        </span>
      </div>
      <button
        (click)="submitForm()"
        [disabled]="evaluateFormValidity()"
        [class]="'ui-g-6 submit-button ' + (currentFlowType === installationFlowType.MainsConnection ? 'continue-button' : '')"
        label="{{
          currentFlowType === installationFlowType.MainsConnection
            ? ('technician-data.form-fields.continue-button' | translate)
            : ('basic-profile.jurisdiction.proceed' | translate)
        }}"
        pButton></button>
    </div>
  </div>
</form>
<app-loader *ngIf="isLoading"></app-loader>
